import { gql } from '@apollo/client';

export const UPDATE_PROVIDER = gql`
  mutation updateProvider($data: UpdateProviderInput!) {
    updateProvider(data: $data)
  }
`;
